import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';

type AlertDialogPropsType = {
  showAlert: any
  cancelNavigation: any
  confirmNavigation: any
}

export const AlertNotSavedChanges = (props: AlertDialogPropsType) => {
  return (
    <div>
      <Dialog
        open={props.showAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Warning
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            There some changes, are sure you want to leave the page ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.cancelNavigation} color="primary">
            No
          </Button>
          <Button onClick={props.confirmNavigation} variant="contained" color="info" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
